/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
import axios from 'axios';
import moment from 'moment';
import { baseURL } from '../constants';
import { authHeader, history } from '../redux/helper';

async function DistributorList(page, searchValue, filterValue, sort, limit = null) {
    let data;

    try {
        if (searchValue !== '') {
            data = await axios.get(`${baseURL}/distributors/list?search=${encodeURIComponent(searchValue)}&limit=${limit || 10}&page=${page}${sort !== '' ? `&sort=${sort}` : ''}${filterValue === 'all' ? '' : `${filterValue}`}`, { headers: authHeader() });
        } else {
            data = await axios.get(`${baseURL}/distributors/list?limit=${limit || 8}&page=${page}${sort !== '' ? `&sort=${sort}` : ''}${filterValue === 'all' ? '' : `${filterValue}`}`, { headers: authHeader() });
        }

        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.response.data.message };
    }
}
async function updateDistributor(body, email) {
    try {
        const data = await axios.patch(`${baseURL}/distributors/update/${email}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function DistributorStatus(body, email) {
    try {
        const data = await axios.patch(`${baseURL}/distributors/update/${email}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function getDistributorDetail(id) {
    try {
        const data = await axios.get(`${baseURL}/distributors/get/${id}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function getDistributorDetailwithTransferUsers(id, order_id) {
    try {
        const data = await axios.get(`${baseURL}/distributors/get/${id}?order_id=${order_id}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function getDistributorAddress(id) {
    try {
        const data = await axios.get(`${baseURL}/distributors/admin/address/${id}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getNewthreepl(search) {
    try {
        const data = await axios.get(`${baseURL}/admin-user/list/3pls`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

//  commenting old code (may be required to debug)
// async function dashboardValues(date, selected) {
//     try {
//         const query = date ? `?date_range=${date}` : (selected !== 'CUSTOM' ? `?date_range=${selected}` : '');
//         const data = await axios.get(`${baseURL}/admin-user/dashboard-values${query}`, {
//             headers: authHeader(),
//         });
//         return { error: false, data: data.data };
//     } catch (error) {
//         return { error: true, message: error.response.data.message };
//     }
// }
async function plantWiseDashboard(date, selected) {
    try {
        const query = date ? `?date_range=${date}` : (selected !== 'CUSTOM' ? `?date_range=${selected}` : '');
        const response = await axios.get(`${baseURL}/admin-user/dashboard/plant-summary${query}`, {
            headers: authHeader(),
        });
        return { error: false, data: response.data };
    } catch (error) {
        return { error: true, message: error.response?.data?.message || error.message };
    }
}

async function dashboardValues(date, selected, key) {
    try {
        const query = date ? `?date_range=${date}&query_type=${key}` : (selected !== 'CUSTOM' ? `?date_range=${selected}&query_type=${key}` : `?query_type=${key}`);
        const response = await axios.get(`${baseURL}/admin-user/dashboard-values${query}`, {
            headers: authHeader(),
        });
        return { error: false, key, data: response.data }; // return key so we know which API returned
    } catch (error) {
        return { error: true, key, message: error.response?.data?.message || error.message };
    }
}

async function shippingOrganizationLocations(currentPage, sort, status, search) {
    try {
        const data = await axios.get(`${baseURL}/admin-user/list/3pls?record=all&limit=10&page=${currentPage}&sort=${sort}${status === '' ? '' : `&ACTIVE_FLAG=${status}`}${search === '' ? '' : `&search=${encodeURIComponent(search)}`}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function shippingOrganizationLocationsForFilter() {
    try {
        const data = await axios.get(`${baseURL}/admin-user/list/3pls?record=all&limit=100`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error?.response?.data?.message };
    }
}

async function UpdateDistributor(id, payload) {
    try {
        if (payload.TEMP_SUPPORT) {
            delete payload.TEMP_SUPPORT;
        }
        const data = await axios.patch(`${baseURL}/distributors/update/${id}`, payload, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function GetRoleDetails(roles, search) {
    try {
        if (roles !== '') {
            const data = await axios.get(`${baseURL}/admin-user/list?admin_status=1&roles=${roles.replace(/\s/g, '_').toLowerCase()}${search === '' ? '' : `&search=${search}`}`, {
                headers: authHeader(),
            });
            return { error: false, data: data.data };
        }
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getOffersMainCategory() {
    try {
        const data = await axios.get(`${baseURL}/categories/list/main-categories`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getOffersSubCategory(mainCategory, sub1, sub2, sub3) {
    try {
        const data = await axios.post(`${baseURL}/categories/list/sub-categories?MAIN_CATEGORY=${mainCategory}${sub1 ? `&SEGMENT2=${sub1}` : ''}${sub2 ? `&SEGMENT3=${sub2}` : ''}${sub3 ? `&SEGMENT4=${sub3}` : ''}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getSku(body) {
    try {
        const data = await axios.post(`${baseURL}/categories/list/sub-categories`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getProductsList() {
    try {
        const data = await axios.get(`${baseURL}/categories/list/products/22898`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function createOffer(body) {
    try {
        const data = await axios.post(`${baseURL}/offers/create`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data?.data };
    } catch (error) {
        return { error: true, message: error?.response?.data?.message };
    }
}
async function UpdateOffer(body, id) {
    try {
        const data = await axios.patch(`${baseURL}/offers/update?code=${encodeURIComponent(id)}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.message };
    }
}

async function createBulkOffer(body) {
    try {
        const data = await axios.post(`${baseURL}/bulk-offers/create`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function UpdateBulkOffer(body, id) {
    try {
        const data = await axios.patch(`${baseURL}/bulk-offers/update?code=${encodeURIComponent(id)}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function ViewOffer(id) {
    try {
        const data = await axios.get(`${baseURL}/offers/get?code=${encodeURIComponent(id)}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.message };
    }
}

async function ViewBulkOffer(id) {
    try {
        const data = await axios.get(`${baseURL}/bulk-offers/get?code=${encodeURIComponent(id)}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.message };
    }
}
async function GetOfferDetails(id) {
    try {
        const data = await axios.get(`${baseURL}/offers/get/${id}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function offerActiveOrDeactivateAccount(body, code) {
    try {
        const data = await axios.patch(`${baseURL}/offers/${body}/?code=${encodeURIComponent(code)}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.message };
    }
}

async function BulkofferActiveOrDeactivate(body, code) {
    try {
        const data = await axios.patch(`${baseURL}/bulk-offers/${body}/?code=${encodeURIComponent(code)}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.message };
    }
}

async function offerActiveOrDeactivateDistributor(body, accountId) {
    try {
        const data = await axios.patch(`${baseURL}/distributors/status/update/${accountId}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.message };
    }
}

async function offerList(page, searchValue, filterValue, sort) {
    let data;
    try {
        if (filterValue === '' || filterValue === undefined) {
            if (page) {
                data = await axios.get(`${baseURL}/offers/list?page=${page}&limit=8${searchValue === '' ? `&sort=${sort} ` : `&search=${encodeURIComponent(searchValue.toLowerCase())}`}`, { headers: authHeader() });
            }
        } else {
            data = await axios.get(`${baseURL}/offers/list?page=${page}&limit=8&${filterValue.substring(1)}&sort=${sort}`, { headers: authHeader() });
        }
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.message };
    }
}
async function handleOfferExport(searchValue, filterValue, sort, sortKey) {
    let data;

    try {
        if (filterValue === '' || filterValue === undefined) {
            if (searchValue === '') {
                // ${searchValue === '' ? `?sort=${sort} ` : `?search=${searchValue.toLowerCase()}
                data = await axios.get(`${sortKey === 'offers/html-to-pdf' ? `${baseURL}/pdf-converter/` : `${baseURL}/offers/`}${sortKey}${searchValue === '' ? `?sort=${sort} ` : `?search=${searchValue.toLowerCase()}`}`, { headers: authHeader() });
            } else {
                data = await axios.get(`${sortKey === 'offers/html-to-pdf' ? `${baseURL}/pdf-converter/` : `${baseURL}/offers/`}${sortKey}${searchValue === '' ? `?sort=${sort} ` : `?search=${searchValue.toLowerCase()}`}`, { headers: authHeader() });
            }
        } else {
            data = await axios.get(`${sortKey === 'offers/html-to-pdf' ? `${baseURL}/pdf-converter/` : `${baseURL}/offers/`}${sortKey}?sort=${sort} ${filterValue}`, { headers: authHeader() });
        }
        return { error: false, data: data.data };
    } catch (error) {
        // if (error.response.status === 401) {
        //     // logout();
        // }
        return { error: true, message: error.message };
    }
}
async function getProductsListByid(id, page) {
    try {
        const data = await axios.get(`${baseURL}/categories/list/sku/${id}?page=${page}&limit=5&sort=CREATION_DATE+asc`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function getProductsListBySegments(body) {
    try {
        const data = await axios.post(`${baseURL}/categories/list/sku`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
// ${baseURL}/pdf-converter/distributors/html-to-pdf?page=${page}&limit=10${sort === '' ? '' : `&sort=${sort}`}
const handleUrl = (url) => {
    let key = `/distributors/${url}`;
    if (url === '/pdf-converter/html-to-pdf') {
        key = '/pdf-converter/distributors/html-to-pdf';
    }
    return key;
};
async function handleDisributorExport(page, searchValue, filterValue, sort, sortKey) {
    let data;

    try {
        if (filterValue === '' || filterValue === undefined) {
            data = await axios.get(`${baseURL}${handleUrl(sortKey)}?page=${page}&limit=10&${searchValue !== '' ? `search=${encodeURI(searchValue.toLowerCase())}` : ''}${sort === '' ? '' : `&sort=${sort}`}`, { headers: authHeader() });
        } else {
            data = await axios.get(`${baseURL}${handleUrl(sortKey)}?page=${page}&limit=10&${sort === '' ? '' : `&sort=${sort}`}${filterValue.substring(1)}`, { headers: authHeader() });
        }
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.response.data.message };
    }
}
async function handleCategoriesExport(sortKey) {
    let data;

    try {
        data = await axios.get(`${baseURL}${sortKey === 'html-to-pdf' ? '/pdf-converter' : ''}/categories/${sortKey}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.response.data.message };
    }
}
async function handleProductsExport(sortKey, payload) {
    try {
        const data = await axios.post(`${baseURL}${sortKey === 'html-to-pdf' ? '/pdf-converter/sku/' : '/categories/'}${sortKey}`, payload, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.message };
    }
}

async function getRoles() {
    try {
        const data = await axios.get(`${baseURL}/admin-user/list/roles`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.message };
    }
}

async function GetDistributorsName(ids, account_type) {
    try {
        const data = await axios.get(`${baseURL}/distributors/get/account-ids?ids=${ids}${account_type === 'Customer' ? '&account_type=Customer' : ''}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.message };
    }
}
async function ViewOrderDetails(id, distributorId) {
    try {
        const data = await axios.get(`${baseURL}/orders/get/${distributorId}/${id}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function OrderValidation(id, distributorId) {
    try {
        const data = await axios.get(`${baseURL}/orders/validation/${distributorId}/${id}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function Getaddress() {
    try {
        const data = await axios.get(`${baseURL}/distributors/address/191524261`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function UpdateAddress(body, distributor_id, order_id) {
    try {
        const data = await axios.patch(`${baseURL}/orders/order-address-update/${distributor_id}/${order_id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function OrderStatusUpdate(body, distributor_id, order_id, threepl) {
    try {
        const data = await axios.patch(`${baseURL}/orders/${threepl ? 'order-3pl-update' : 'order-approval'}/${distributor_id}/${order_id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function transferOrder(body, distributor_id, order_id) {
    try {
        const data = await axios.patch(`${baseURL}/orders/transfer/${distributor_id}/${order_id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function OrderDiscountUpdate(body, distributor_id, order_id) {
    try {
        const data = await axios.patch(`${baseURL}/orders/discount-update/${distributor_id}/${order_id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function OrderrevisedPriceUpdate(body, distributor_id, order_id, threepl) {
    try {
        const data = await axios.patch(`${baseURL}/orders/order-revise-update/${distributor_id}/${order_id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function PendingApprovalList(page, sort, searchValue, filterValue, exportval) {
    try {
        const exportKey = exportval === undefined ? 'list' : `${exportval}`;
        let finalUrl = '';
        if (!exportKey.includes('pdf')) { finalUrl = `orders/${exportKey}?status=1,2&page=${page}&limit=10${searchValue !== '' ? `&search=${searchValue}` : ''}${filterValue ? `${filterValue}` : ''}&sort=${sort}`; } else finalUrl = `pdf-converter/orders?status=1,2&page=${page}&limit=10${searchValue !== '' ? `&search=${searchValue}` : ''}${filterValue ? `${filterValue}` : ''}&sort=${sort}`;
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.response.data.message };
    }
}

async function ApprovalList(page, sort, searchValue, filterValue, exportval) {
    try {
        const exportKey = exportval === undefined ? 'list' : `${exportval}`;
        let finalUrl = '';
        if (!exportKey.includes('pdf')) { finalUrl = `orders/${exportKey}?page=${page}&limit=10${searchValue !== '' ? `&search=${searchValue}` : ''}${filterValue ? `${filterValue}` : ''}&sort=${sort}`; } else finalUrl = `pdf-converter/orders?page=${page}&limit=10${searchValue !== '' ? `&search=${searchValue}` : ''}${filterValue ? `${filterValue}` : ''}&sort=${sort}`;
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.response.data.message };
    }
}

async function CreateOrder(body) {
    body.order_from = 'Web';
    try {
        const data = await axios.post(`${baseURL}/orders/create`, body, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetProductsFiters(category, queryString = '') {
    try {
        const data = await axios.get(`${baseURL}/categories/filters/${category}${queryString}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetFOBFeight() {
    try {
        const data = await axios.get(`${baseURL}/categories/get/fob-freight`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetProductList(body) {
    const payload = body;
    // payload.distributor_id = String(210261264);
    try {
        const data = await axios.post(`${baseURL}/categories/list/distributor/products`, payload, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function OrderInvoiceDetails(id, distributorId) {
    try {
        const data = await axios.get(`${baseURL}/invoices/get/invoice/${distributorId}/${id}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function UploadInvoiceDocuments(order_number, invoice_id, payload) {
    try {
        const data = await axios.patch(`${baseURL}/invoices/update/${order_number}/${invoice_id}`, payload, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function CreateCategory(body) {
    try {
        const data = await axios.post(`${baseURL}/resource/categories-create`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function UpdateCategory(body, id) {
    try {
        const data = await axios.patch(`${baseURL}/resource/categories-update/${id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function CreateCategoryList(currentPage, searchValue) {
    try {
        const data = await axios.get(`${baseURL}/resource/categories-list?limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function CategoryList() {
    try {
        const data = await axios.get(`${baseURL}/resource/categories-list`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function CreateResource(body) {
    try {
        const data = await axios.post(`${baseURL}/resource/create`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function ResourceList(currentPage, searchValue, sort) {
    try {
        const data = await axios.get(`${baseURL}/resource/list?limit=10&page=${currentPage}&sort=${sort}${searchValue === '' ? '' : `&search=${encodeURIComponent(searchValue)}`}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function DeleteResource(id, body) {
    try {
        const data = await axios.delete(`${baseURL}/resource/delete/${id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function UpdateResource(body, id) {
    try {
        const data = await axios.patch(`${baseURL}/resource/update/${id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function InvoicesList(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `invoices/list?sort=${sortType}&limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue ? `${filterValue}` : ''}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/invoices/html-to-pdf/?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue ? `${filterValue}` : ''}`;
    } else {
        finalUrl = `invoices/export-${exportSelected}?sort=${sortType}&limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue ? `${filterValue}` : ''}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function ReturnRequestList(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `invoices/list?sort=${sortType}&limit=10&PAYMENT_STATUS=REQUEST FOR RETURN&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue ? `${filterValue}` : ''}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/invoices/html-to-pdf/?sort=${sortType}&limit=10&PAYMENT_STATUS=REQUEST FOR RETURN&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue ? `${filterValue}` : ''}`;
    } else {
        finalUrl = `invoices/export-${exportSelected}?sort=${sortType}&limit=10&PAYMENT_STATUS=REQUEST FOR RETURN&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue ? `${filterValue}` : ''}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function ParticularCustomerInvoicesList(id, invoicesearchValue) {
    try {
        const data = await axios.get(`${baseURL}/invoices/pending-list?distributor_ids=${id}&PAYMENT_STATUS=true${invoicesearchValue === '' ? '' : `&search=${invoicesearchValue}`}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

// async function ViewInvoicesDetails(invoiceNumber) {
//     try {
//         const data = await axios.get(`${baseURL}/invoices/get/${invoiceNumber}`, { headers: authHeader() });
//         return { error: false, data: data.data };
//     } catch (error) {
//         return { error: true, message: error };
//     }
// }

async function ViewInvoicesDetails(invoiceNumber, isPresigned) {
    if (isPresigned) {
        try {
            const data = await axios.get(`${baseURL}/invoices/get/${invoiceNumber}?presigned=true`, { headers: authHeader() });
            return { error: false, data: data.data };
        } catch (error) {
            return { error: true, message: error };
        }
    }
    try {
        const data = await axios.get(`${baseURL}/invoices/get/${invoiceNumber}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function TransactionsList(currentPage, sortType, searchValue, filterValue) {
    try {
        const data = await axios.get(`${baseURL}/orders/payment-list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function UpdateParticularTransaction(transaction_id, body) {
    try {
        const data = await axios.patch(`${baseURL}/orders/payment-update/${transaction_id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

// mis reports

async function MISAreaWiseCustomerOutstandingReport(id, currentPage, searchValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/specific-area-wise-customer-outsrtanding-report/list?page=${currentPage}&area_code=${id}${searchValue === '' ? '' : `&search=${searchValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/specific-area-wise-customer-outstanding/export?page=${currentPage}&area_code=${id}${searchValue === '' ? '' : `&search=${searchValue}`}`;
    } else {
        finalUrl = `mis-reports/specific-area-wise-customer-outsrtanding-report-${exportSelected}/list?page=${currentPage}&area_code=${id}${searchValue === '' ? '' : `&search=${searchValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISAreaWiseOutstandingReport(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/area-wise-customer-outsrtanding-report/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/area-wise_customer-outstanding/export?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/area-wise-customer-outsrtanding-report-${exportSelected}/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISFGStockReports(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/fg-stocks-report/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/fg-stock/export?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/fg-stocks-report-${exportSelected}/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISIndentReport(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/indent/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/indent-report/export?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/indent-${exportSelected}/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISOutstandingInvoiceDetails(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/outstanding-invoice/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/outstanding-invoice/export?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/outstanding-invoice-${exportSelected}/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISInvoiceReport(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/invoice/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/invoice/export?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/invoice-${exportSelected}/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISCustomerWiseOutstandingReportList(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/customer-wise-outstanding-report/list?limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/customer-wise-outstanding-report/export?limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/customer-wise-outstanding-report-${exportSelected}/list?limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISViewCustomerWiseOutstandingReport(custId, currentPage, searchValue, sortType, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/outstanding-invoice/list?customer_code=${custId}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/outstanding-invoice/export?customer_code=${custId}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/outstanding-invoice-${exportSelected}/list?customer_code=${custId}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function MISPendingOrderReport(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/pending-order/list?limit=8&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/pending-order/export?limit=8&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/pending-order-${exportSelected}/list?limit=8&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function AdorCashList(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === undefined || exportSelected === '') {
        finalUrl = `invoices/admin/ador-cash/distributors?limit=8&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}`;
    } else {
        finalUrl = `invoices/admin/ador-cash/distributors?limit=8&page=${currentPage}&export=${exportSelected}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function AdorCashSync() {
    try {
        const data = await axios.get(`${baseURL}/invoices/sync-manual`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function ParticularDistributorAdorCashList(id, currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === undefined || exportSelected === '') {
        finalUrl = `invoices/ador-cash/${id}/list?limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else {
        finalUrl = `invoices/ador-cash/${id}/list?limit=10&page=${currentPage}&export=${exportSelected}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function AdorCashAdjustment(body) {
    try {
        const data = await axios.post(`${baseURL}/invoices/admin/ador-cash/adjustment`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function GetAllProductsFiters() {
    const { ACCOUNT_NUMBER } = JSON.parse(localStorage.getItem('user')).profile;

    try {
        const data = await axios.get(`${baseURL}/categories/admin/all/filters`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
async function FormulaSetting() {
    try {
        const data = await axios.get(`${baseURL}/admin-user/formula-get  `, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function UpdateFormulaSetting(body) {
    try {
        const data = await axios.patch(`${baseURL}/admin-user/formula-update  `, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function FormulaActivityLog() {
    try {
        const data = await axios.get(`${baseURL}/admin-user/formula-log  `, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function UpdateDistributorAppAccess(enabled) {
    try {
        const data = await axios.patch(`${baseURL}/admin-user/distributor-app-access`, { enabled }, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response?.data?.message };
    }
}

async function Promotions(currentPage, sortType, searchValue, filterValue) {
    try {
        const data = await axios.get(`${baseURL}/promotion/list?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function UpdatePromotions(id, body) {
    try {
        const data = await axios.patch(`${baseURL}/promotion/update/${id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function DeletePromotions(id, body) {
    try {
        const data = await axios.delete(`${baseURL}/promotion/delete/${id}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function CreatePromotions(body) {
    try {
        const data = await axios.post(`${baseURL}/promotion/create`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function StockList(body) {
    try {
        const data = await axios.post(`${baseURL}/categories/list/sku-admin`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function AdminProductListing(currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `categories/list/sku-categories-admin?limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else {
        finalUrl = `categories/list/sku-categories-admin?limit=10&page=${currentPage}&export=${exportSelected}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function PriceList(body) {
    try {
        const data = await axios.post(`${baseURL}/categories/list/price-list-admin`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function NotifyUser(body) {
    try {
        const data = await axios.post(`${baseURL}/orders/notify-user`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function BulkOfferList(url) {
    try {
        const data = await axios.get(`${baseURL}/bulk-offers/list?${url}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function BulkOfferSubscribersList(id, currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `bulk-offers/subscription/list?offer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else {
        finalUrl = `bulk-offers/subscription/list?offer_code=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}&export=${exportSelected}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function BulkOfferSubscriberedOrders(id, currentPage, sortType, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `orders/list?view_all=true&subscription=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/orders/list?view_all=true&subscription=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    } else {
        finalUrl = `orders/export-${exportSelected}/list?view_all=true&subscription=${id}&limit=10&page=${currentPage}&sort=${sortType}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `&${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function BulkOrderDetails(distributor_id, subscription_id) {
    try {
        const data = await axios.get(`${baseURL}/bulk-offers/get/subscription/${distributor_id}/${subscription_id}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function getAllIndusty() {
    try {
        const data = await axios.get(`${baseURL}/categories/list/industry`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

async function checkDirectOrderEligibility(distributorId, category) {
    try {
        const data = await axios.get(`${baseURL}/orders/check-eligibility/${distributorId}?product_category=${category}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response?.data };
    }
}

async function CartDealList(id, disId) {
    const { ACCOUNT_NUMBER } = JSON.parse(localStorage.getItem('user')).profile;
    try {
        const data = await axios.get(`${baseURL}/cart/bulk-offer/list/${disId}?subscription=${id}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}
// Cancel Order
async function OrderCancel(path, body) {
    try {
        const data = await axios.patch(`${baseURL}/orders/order-cancel/${path}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}

// Credit/Debit Details
async function CreditDebitDetailsList(currentPage, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    const searchParam = searchValue ? `&search=${searchValue}` : '';
    const filterParam = filterValue || '';

    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `credit-debit-details/list?limit=10&page=${currentPage}${searchParam}${filterParam}`;
    } else if (exportSelected === 'pdf-converter') {
        finalUrl = `pdf-converter/credit-debit-details/html-to-pdf/?limit=10&page=${currentPage}${searchParam}${filterParam}`;
    } else {
        finalUrl = `credit-debit-details/export-${exportSelected}?limit=10&page=${currentPage}${searchParam}${filterParam}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

// Export Credit/Debit Details
async function ExportCreditDebitDetails(exportType, selected, filterValue, searchValue) {
    try {
        // Format date range as DD-MM-YYYY,DD-MM-YYYY
        const dateRange = `${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;

        // Build query parameters
        let queryParams = `export=${exportType}&date_range=${dateRange}`;

        // Add search parameter if exists
        if (searchValue) {
            queryParams += `&search=${encodeURIComponent(searchValue)}`;
        }

        // Parse filterValue to extract other filter parameters
        // filterValue format: &transaction_type=...&customer_code=...&org_code=...
        if (filterValue) {
            // Remove date_range from filterValue if present (we're using it separately)
            const filterParams = filterValue.split('&').filter((param) => param && !param.includes('date_range'));
            if (filterParams.length > 0) {
                queryParams += `&${filterParams.join('&')}`;
            }
        }

        const finalUrl = `credit-debit-details/export?${queryParams}`;
        const data = await axios.get(`${baseURL}/${finalUrl}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response?.data?.message || error.message, data: error.response?.data };
    }
}

async function GetTransactionTypes(page = 1, limit = 50) {
    try {
        const data = await axios.get(`${baseURL}/credit-debit-details/transaction-types?page=${page}&limit=${limit}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetOrganizationCodes(page = 1, limit = 50) {
    try {
        const data = await axios.get(`${baseURL}/credit-debit-details/org-codes?page=${page}&limit=${limit}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function GetCreditDebitDocument(creditDebitLink) {
    try {
        const data = await axios.get(`${baseURL}/credit-debit-details/document/${creditDebitLink}?presigned=true`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error };
    }
}

async function IPOrderReportList(currentPage, searchValue, filterValue, exportSelected) {
    let finalUrl = '';
    if (exportSelected === '' || exportSelected === undefined) {
        finalUrl = `mis-reports/ip-order-report/list?limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else if (exportSelected === 'pdf') {
        finalUrl = `pdf-converter/ip-order-report/export?limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    } else {
        finalUrl = `mis-reports/ip-order-report-${exportSelected}/list?limit=10&page=${currentPage}${searchValue === '' ? '' : `&search=${searchValue}`}${filterValue === '' ? '' : `${filterValue}`}`;
    }
    try {
        const data = await axios.get(`${baseURL}/${finalUrl}`, { headers: authHeader() });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response?.data?.message || error.message };
    }
}

export const distributorService = {
    DistributorList,
    updateDistributor,
    DistributorStatus,
    getDistributorDetail,
    getNewthreepl,
    UpdateDistributor,
    GetRoleDetails,
    getOffersMainCategory,
    getOffersSubCategory,
    getProductsList,
    createOffer,
    GetOfferDetails,
    offerActiveOrDeactivateAccount,
    offerActiveOrDeactivateDistributor,
    offerList,
    UpdateOffer,
    handleOfferExport,
    getProductsListByid,
    handleDisributorExport,
    getSku,
    getProductsListBySegments,
    handleCategoriesExport,
    handleProductsExport,
    getRoles,
    ViewOffer,
    GetDistributorsName,
    ViewOrderDetails,
    Getaddress,
    UpdateAddress,
    OrderStatusUpdate,
    OrderrevisedPriceUpdate,
    PendingApprovalList,
    CreateOrder,
    GetProductsFiters,
    GetProductList,
    GetFOBFeight,
    ApprovalList,
    OrderValidation,
    OrderInvoiceDetails,
    UploadInvoiceDocuments,
    shippingOrganizationLocations,
    shippingOrganizationLocationsForFilter,
    CreateCategory,
    CreateCategoryList,
    CreateResource,
    ResourceList,
    CategoryList,
    DeleteResource,
    UpdateResource,
    UpdateCategory,
    MISAreaWiseCustomerOutstandingReport,
    MISAreaWiseOutstandingReport,
    MISFGStockReports,
    MISIndentReport,
    MISOutstandingInvoiceDetails,
    MISInvoiceReport,
    MISCustomerWiseOutstandingReportList,
    MISViewCustomerWiseOutstandingReport,
    InvoicesList,
    ViewInvoicesDetails,
    TransactionsList,
    ParticularCustomerInvoicesList,
    UpdateParticularTransaction,
    MISPendingOrderReport,
    AdorCashList,
    ParticularDistributorAdorCashList,
    AdorCashAdjustment,
    GetAllProductsFiters,
    FormulaSetting,
    UpdateFormulaSetting,
    FormulaActivityLog,
    UpdateDistributorAppAccess,
    ReturnRequestList,
    Promotions,
    CreatePromotions,
    UpdatePromotions,
    DeletePromotions,
    getDistributorAddress,
    dashboardValues,
    plantWiseDashboard,
    StockList,
    PriceList,
    AdminProductListing,
    BulkOfferList,
    createBulkOffer,
    UpdateBulkOffer,
    ViewBulkOffer,
    BulkofferActiveOrDeactivate,
    BulkOfferSubscribersList,
    BulkOfferSubscriberedOrders,
    BulkOrderDetails,
    getAllIndusty,
    CartDealList,
    NotifyUser,
    AdorCashSync,
    OrderCancel,
    checkDirectOrderEligibility,
    transferOrder,
    getDistributorDetailwithTransferUsers,
    CreditDebitDetailsList,
    ExportCreditDebitDetails,
    GetTransactionTypes,
    GetOrganizationCodes,
    GetCreditDebitDocument,
    IPOrderReportList,
};
